import { ref } from "vue";

export default function usePromise(fn) {
  const results = ref(null);
  const loading = ref(false);
  const error = ref(null);

  const run = async (...args) => {
    loading.value = true;
    error.value = null;
    results.value = null;
    try {
      results.value = await fn(...args);
    } catch (errors) {
      error.value = errors;
    } finally {
      loading.value = false;
    }
  };

  return { results, loading, error, run };
}
